import e from"react";import r from"prop-types";import t from"styled-components";import{ColorTokens as a}from"@vds-tokens/color";const o=a.elements.primary.onlight.value,i=a.elements.primary.ondark.value,n={surface:r.oneOf(["light","dark"]),children:r.node,ariaLabel:r.string,id:r.string},s=t.ul.withConfig({displayName:"StyledUl",componentId:"VDS__sc-1fa46xw-0"})`
  padding: 0;
  margin: 0;
  li,
  ul li {
    color: ${function({surface:e}){return"dark"===e?i:o}} !important;
  }
`,l=function(r){const{id:t,children:a,className:o,surface:i}=r;return e.createElement(s,{id:t,className:o,surface:i},a)};l.propTypes=n,l.defaultProps={surface:"light"},l.displayName="UnorderedList";export{l as default};
